module.exports = __webpack_public_path__ + "static/media/img9.42682e68.jpg";